import { FC } from 'react';

import { useSearchParams } from 'react-router-dom';

import { AdminBugoAnalyticsTab } from '../analytics/AdminBugoAnalyticsTab';
import { AdminOrderAnalyticsTab } from '../analytics/AdminOrderAnalyticsTab';
import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

const TABS = [
  { key: 'bugo', label: '부고' },
  { key: 'flower', label: '화환' },
  { key: 'gift', label: '답례품' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

const isTabKey = (value: string | null): value is TabKey =>
  TABS.some((tab) => tab.key === value);

const AdminAnalyticsPage: FC = () => {
  useAdminTitleHook('통계 · 데이터 분석');

  //* 탭을 URL에 두어 새로고침·뒤로가기에서 유지된다
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tab: TabKey = isTabKey(tabParam) ? tabParam : 'bugo';

  const onTabClick = (next: TabKey) => {
    setSearchParams(next === 'bugo' ? {} : { tab: next }, { replace: true });
  };

  return (
    <div className="space-y-3 p-3 pb-10">
      <div className="flex gap-1 border-b border-gray-200">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onTabClick(item.key)}
            className={`-mb-px border-b-2 px-5 py-2.5 text-16 font-medium ${
              tab === item.key
                ? 'border-indigo-600 text-indigo-700'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* 탭을 바꾸면 조회 조건이 초기화되도록 key로 마운트를 나눈다
          (화환·답례품은 날짜 축이 서로 달라 기간 상태를 공유하면 헷갈린다) */}
      {tab === 'bugo' && <AdminBugoAnalyticsTab />}
      {tab === 'flower' && <AdminOrderAnalyticsTab key="flower" kind="flower" />}
      {tab === 'gift' && <AdminOrderAnalyticsTab key="gift" kind="gift" />}
    </div>
  );
};

export default AdminAnalyticsPage;
